module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [
      _vm.type === 'textarea' ? 'zk-textarea' : 'zk-input',
      _vm.size ? 'zk-input--' + _vm.size : '',
      {
        'is-disabled': _vm.disabled,
        'zk-input-group': _vm.$slots.prepend || _vm.$slots.append
      }
    ]
  }, [(_vm.type !== 'textarea') ? [(_vm.$slots.prepend) ? _c('div', {
    staticClass: "zk-input-group__prepend"
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.icon) ? _c('i', {
    staticClass: "zk-input__icon",
    class: [_vm.icon ? 'zk-icon-' + _vm.icon : ''],
    on: {
      "click": _vm.handleIconClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type !== 'textarea') ? _c('input', {
    ref: "input",
    staticClass: "zk-input__inner",
    attrs: {
      "type": _vm.type,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "maxlength": _vm.maxlength,
      "minlength": _vm.minlength,
      "autocomplete": _vm.autoComplete,
      "autofocus": _vm.autofocus,
      "min": _vm.min,
      "max": _vm.max,
      "form": _vm.form
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleInput,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur
    }
  }) : _vm._e(), _vm._v(" "), (_vm.validating) ? _c('i', {
    staticClass: "zk-input__icon zk-icon-loading"
  }) : _vm._e(), _vm._v(" "), (_vm.$slots.append) ? _c('div', {
    staticClass: "zk-input-group__append"
  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentValue),
      expression: "currentValue"
    }],
    ref: "textarea",
    staticClass: "zk-textarea__inner",
    style: (_vm.textareaStyle),
    attrs: {
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly,
      "rows": _vm.rows,
      "form": _vm.form,
      "autofocus": _vm.autofocus,
      "maxlength": _vm.maxlength,
      "minlength": _vm.minlength
    },
    domProps: {
      "value": (_vm.currentValue)
    },
    on: {
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentValue = $event.target.value
      }
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.1.4@vue-loader/lib/template-compiler.js?{"id":"data-v-13a2355f"}!./~/.11.1.4@vue-loader/lib/selector.js?type=template&index=0!./src/packages/input/src/input.vue
// module id = 236
// module chunks = 0